import React from "react";

import styles from "./SearchInput.module.scss";

const SearchInput = ({ placeholder, onSearch, onChange }) => {
  return (
    <div className={styles.search_input}>
      <input
        type="text"
        id="search-input"
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <i className="icon-search" onClick={() => onSearch()}></i>
    </div>
  );
};

export default SearchInput;
